import React from 'react'
import ServicesSection from '../Services/ServicesSection'

const Courses = () => {
  return (
    <div>
      <ServicesSection/>
    </div>
  )
}

export default Courses